export default "__VITE_ASSET__DYjv0zvF__"